<template>
  <div class="page page-full page-cancelable">
    <b-tabs pills lazy>
      <b-tab title="Main" active>
        <report-main />
      </b-tab>
      <b-tab title="Final Report" v-if="isAdmin">
        <report-final-report />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import ReportMain from './report-main';
  import ReportFinalReport from './report-final-report';

  export default {
    components: {
      ReportMain,
      ReportFinalReport
    },

    computed: {
      isAdmin() {
        return this.$auth.isInRole("Admin");
      }
    },
  };
</script>